{
  "de": {
    "materials": {
      "collectionEmpty": {
        "communityTab": "Schau mal im Material der fobizz Community nach.",
        "partnerTab": "Schau mal im Material von fobizz & Partnern nach.",
        "title": "Nichts gefunden?",
        "viewCommunityMaterial": "Zum Material der fobizz Community",
        "viewPartnerMaterial": "Zum Material von fobizz & Partnern"
      },
      "collectionTeaser": {
        "linkName": "Mehr erfahren",
        "title": "Vollständige Unterrichtsentwürfe in den Kollektionen"
      },
      "filters": {
        "international": {
          "false": "DE",
          "true": "EN"
        },
        "language": "Sprache",
        "order": {
          "label": "Sortiere nach",
          "newest": "Neueste",
          "relevance": "Relevanz"
        }
      },
      "galleryTeaser": {
        "linkName": "Mehr erfahren",
        "title": "So nutzt du die Materialien der Galerie optimal"
      },
      "headings": {
        "toTeach": "Diese Inhalte stammen von unserem <a href=\"https://app.fobizz.com/partners/34-to-teach\" target=\"_blank\">Partner to teach</a>. Mit einem kostenfreien to teach Konto kannst du unbegrenzt bestehende to teach Inhalte verwenden und pro Monat 10 neue anlegen. <a href=\"https://app.fobizz.com/de/help/articles/271-to-teach-abo-kostenlos\" target=\"_blank\">Mehr erfahren.</a>"
      },
      "howTo": {
        "header": {
          "heading": "Die fobizz Galerie - das erwartet dich",
          "list_html": "<li><i class='bi bi-check-lg'></i>Inspiration von anderen Lehrkräften für deinen Unterricht</li>\n<li><i class='bi bi-check-lg'></i>Praxiserprobte und kostenfreie Materialien zum Weiterverwenden</li>\n<li><i class='bi bi-check-lg'></i>Einfaches Anpassen von Vorlagen und Beispielen mit den fobizz Tools</li>\n<li><i class='bi bi-check-lg'></i>Zeitersparnis durch Austausch von Materialien und Unterrichtsideen</li>\n<li><i class='bi bi-check-lg'></i>Kollektionen mit fertigen Unterrichtsentwürfen zu bestimmten Themen </li>"
        },
        "recommendations": {
          "heading": "Entdecke aktuelle Kollektionen"
        },
        "terms": {
          "collections": {
            "description_html": "In der Galerie findest du Sammlungen von Unterrichtsmaterialien <strong>zu bestimmten Themen</strong>. Du kannst dir einzelne Elemente herauspicken und adaptieren oder gleich <strong>vollständige Unterrichtsentwürfe</strong> mit allen benötigten Materialien im Unterricht einsetzen.",
            "heading": "Kollektionen?"
          },
          "copyright": {
            "description_html": "Im Sinne der <strong>OER</strong> (Open Educational Resources) stehen alle Inhalte, die Lehrer*innen in der Galerie veröffentlichen, unter der <a href=\"https://creativecommons.org/licenses/by/3.0/de/\" target=\"_blank\">Creative Commons Lizenz CC-BY</a>. Das heißt, du darfst sie kostenfrei verwenden, bearbeiten und weiterverbreiten.",
            "heading": "Urheberrecht?"
          },
          "description": "Die folgenden Begriffe begegnen dir in der Galerie. Was sich dahinter verbirgt, erfährst du hier!",
          "heading": "Was ist eigentlich mit...",
          "link": "Jetzt Unterrichtsmaterialien entdecken",
          "remix": {
            "description_html": "Mit nur einem Klick auf den <strong>Remix Button</strong> kannst du jedes Material der Galerie in deine <strong>eigene Ablage</strong> kopieren - wie eine digitale Kopiervorlage. Setze das Material direkt im Unterricht ein oder passe einzelne Elemente vor der Verwendung flexibel an.",
            "heading": "Remix?"
          }
        },
        "tile": {
          "heading": "Finde Inhalte, die genau zu dir passen",
          "help": {
            "author": "Autor*in des Materials",
            "bookmark": "Herz für deine Merkliste",
            "kind": "Art der Inhalte"
          },
          "link": "Zurück zur Galerie",
          "list_html": "<li><i class='bi bi-check-lg'></i>Suche nach <strong>Themen und Schlagworten</strong> und grenze die Ergebnisse weiter ein: nach empfohlener Schulform, Altersgruppe oder Fach.</li>\n<li><i class='bi bi-check-lg'></i>Merke dir interessante Inhalte für später mit Klick auf das Herz und finde sie in deiner <strong>persönlichen Merkliste</strong>.</li>\n<li><i class='bi bi-check-lg'></i>Erfasse die <strong>Beliebtheit eines Materials</strong> auf einen Blick. Mit der Anzahl der Remixes siehst du, wie häufig es schon weiterverwendet wurde.</li>",
          "material_title": "Nie wieder Hausaufgaben? KI - Möglichkeiten und Grenzen"
        },
        "title": "Alles Wissenwerte zur Galerie"
      },
      "labels": {
        "approvedUserIds": "Partner",
        "filterCollection": "Kollektion",
        "galleryCommunityPlaceholder": "fobizz Community Material durchsuchen",
        "galleryFallbackPlaceholder": "Inhalte durchsuchen",
        "galleryPlaceholder": "fobizz & Partner Material durchsuchen",
        "galleryToTeachPlaceholder": "to teach Inhalte durchsuchen",
        "models": "Materialtypen"
      },
      "searchPlaceholder": "fobizz Material durchsuchen...",
      "toTeachImport": {
        "importFailed": "Import fehlgeschlagen. Bitte versuche es erneut.",
        "importNotFound": "Das Arbeitsblatt wurde nicht gefunden.",
        "importReady": "Dein to teach Arbeitsblatt wurde erfolgreich importiert!"
      }
    }
  }
}
